<template>
  <div class="mt-5">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 mr-3">
          <strong>รายละเอียดการขายหลักสูตร</strong>
        </h5>

        <div class="text-muted mb-0">คอร์สทั้งหมด {{ items.length }} คอร์ส</div>
      </div>

      <CourseSalesReportPDF
          :courseSales="items"
          :courseSalesParamsValue="paramsValue"
          :courseSalesParamsLabel="paramsLabel"
          :btnDisabled=false
      ></CourseSalesReportPDF>
    </div>

    <div class="text-warning mb-4">
      หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
      และดาวน์โหลดลงบนเครื่องของคุณ
    </div>

    <div class="table-responsive">
      <table class="table custom-table">
        <thead>
          <tr>
            <th width="70%">หลักสูตร</th>
            <th width="15%" class="text-center">
              ยอดขาย (ครั้ง)
            </th>
            <th width="15%" class="text-center">
              รวมเงิน (บาท)
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.courseName }}</td>

            <td class="text-center">
              {{ numberFormat(item.count) }}
            </td>

            <td class="text-right">
              {{ numberFormat(item.sum) || 0 }}
            </td>
          </tr>

          <!-- TOTAL -->
          <tr class="summary-row">
            <td>
              <strong>รวมทั้งหมด</strong>
            </td>

            <td class="text-center">
              <strong>
                {{ numberFormat(totalSales) }}
              </strong>
            </td>

            <td class="text-right">
              <strong>
                {{ numberFormat(totalAmount) }}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CourseSalesReportPDF from "@/components/reports/course-sales-report/CourseSalesReportPDF.vue";

export default {
  components: {
    CourseSalesReportPDF,
  },
  name: "CourseSalesReportPanel",

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    paramsValue: {
      type: Object,
      default: () => {},
    },

    paramsLabel: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    totalSales() {
      return this.items.reduce((sum, item) => {
        return sum + Number(item.count || 0);
      }, 0);
    },
    totalAmount() {
      return this.items.reduce((sum, item) => {
        return sum + Number(item.sum || 0);
      }, 0);
    },
  },
  methods: {
    numberFormat(value) {
      return Number(value || 0).toLocaleString();
    },
  },
};
</script>

<style scoped>
.custom-table {
  border: 1px solid #cfd4da;
}

.custom-table thead th {
  background: #f5f5f5;
  border: 1px solid #cfd4da;
  padding: 14px;
  font-weight: 600;
}

.custom-table tbody td {
  border: 1px solid #dee2e6;
  padding: 14px;
  vertical-align: middle;
}

.summary-row {
  background: #e9ecef;
}
</style>
